// v2/hooks/useAdminAnnouncements.js — yonetim: gorsel duyurular (banner)
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, apiPost } from '../utils/api';

export default function useAdminAnnouncements() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tetik, setTetik] = useState(0);
  const abortRef = useRef(null);

  const yenile = useCallback(() => setTetik((n) => n + 1), []);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    apiGet('/v2/admin/announcements/', { signal: ctrl.signal })
      .then((veri) => {
        if (ctrl.signal.aborted) return;
        if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Liste alınamadı');
        setData({
          items: Array.isArray(veri.items) ? veri.items : [],
          today: veri.today || '',
          limits: veri.limits || { max: 10, maxActive: 5 },
        });
      })
      .catch((e) => {
        if (ctrl.signal.aborted || (e && e.name === 'AbortError')) return;
        setError((e && e.message) || 'Liste alınamadı');
      })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [tetik]);

  return { data, loading, error, yenile };
}

/** Liste ogesi -> form alanlari (guncellemede tum alanlar gonderilir) */
export function itemdenAlanlar(it) {
  return {
    baslik: it.title || '',
    link: it.href || '',
    sira: it.order || 0,
    aktif: Boolean(it.active),
    baslangic: it.start || '',
    bitis: it.end || '',
  };
}

function formVerisi(alanlar, dosya) {
  const fd = new FormData();
  fd.append('baslik', alanlar.baslik || '');
  fd.append('link', alanlar.link || '');
  fd.append('sira', String(alanlar.sira || 0));
  fd.append('aktif', alanlar.aktif ? '1' : '0');
  fd.append('baslangic', alanlar.baslangic || '');
  fd.append('bitis', alanlar.bitis || '');
  if (dosya) fd.append('gorsel', dosya);
  return fd;
}

export const adminAnnouncementApi = {
  ekle: (alanlar, dosya) =>
    apiPost('/v2/admin/announcements/create/', formVerisi(alanlar, dosya)),
  guncelle: (id, alanlar, dosya) =>
    apiPost(`/v2/admin/announcements/${id}/update/`, formVerisi(alanlar, dosya)),
  sil: (id) => apiPost(`/v2/admin/announcements/${id}/delete/`),
  sirala: (ids) => apiPost('/v2/admin/announcements/reorder/', { ids }),
};
